import { Suspense, type FC } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { type SparkBalancePillQuery } from '@/__generated__/SparkBalancePillQuery.graphql'
import { HStack, Icon, Pressable, Text } from '@/components'
import { COLOR_WHITE } from '@/lib'

import { SparkIcon } from './SparkIcon'

interface SparkBalancePillProps {
  onPress?: () => void
}

const SparkBalancePillInner: FC<SparkBalancePillProps> = ({ onPress }) => {
  const data = useLazyLoadQuery<SparkBalancePillQuery>(
    graphql`
      query SparkBalancePillQuery {
        currentUser {
          sparkBalance
        }
      }
    `,
    {},
    { fetchPolicy: 'store-and-network' }
  )
  const balance = data?.currentUser?.sparkBalance ?? 0

  const content = (
    <HStack className='items-center gap-1 rounded-full'>
      <Icon
        as={SparkIcon}
        className='h-6 w-6'
        fill={COLOR_WHITE}
        stroke='none'
      />
      <Text className='font-poppinsBold text-xl text-white'>{balance}</Text>
    </HStack>
  )

  if (!onPress) {
    return <HStack accessibilityLabel={`${balance} Sparks`}>{content}</HStack>
  }

  return (
    <Pressable
      accessibilityLabel={`${balance} Sparks. Tap to buy more.`}
      accessibilityRole='button'
      onPress={onPress}
    >
      {content}
    </Pressable>
  )
}

export const SparkBalancePill: FC<SparkBalancePillProps> = ({ onPress }) => (
  <Suspense fallback={null}>
    <SparkBalancePillInner onPress={onPress} />
  </Suspense>
)
